__turbopack_context__.v({
  "answer": "WebV2FaqSection-module-scss-module__4ztfSG__answer",
  "answerInner": "WebV2FaqSection-module-scss-module__4ztfSG__answerInner",
  "answerWrap": "WebV2FaqSection-module-scss-module__4ztfSG__answerWrap",
  "answerWrapOpen": "WebV2FaqSection-module-scss-module__4ztfSG__answerWrapOpen",
  "chevron": "WebV2FaqSection-module-scss-module__4ztfSG__chevron",
  "chevronOpen": "WebV2FaqSection-module-scss-module__4ztfSG__chevronOpen",
  "container": "WebV2FaqSection-module-scss-module__4ztfSG__container",
  "hpv2Blink": "WebV2FaqSection-module-scss-module__4ztfSG__hpv2Blink",
  "hpv2DemoBounce": "WebV2FaqSection-module-scss-module__4ztfSG__hpv2DemoBounce",
  "hpv2DemoFadeIn": "WebV2FaqSection-module-scss-module__4ztfSG__hpv2DemoFadeIn",
  "hpv2DemoProgress": "WebV2FaqSection-module-scss-module__4ztfSG__hpv2DemoProgress",
  "hpv2DemoScaleIn": "WebV2FaqSection-module-scss-module__4ztfSG__hpv2DemoScaleIn",
  "hpv2DemoSlideIn": "WebV2FaqSection-module-scss-module__4ztfSG__hpv2DemoSlideIn",
  "hpv2FadeLeft": "WebV2FaqSection-module-scss-module__4ztfSG__hpv2FadeLeft",
  "hpv2FadeRight": "WebV2FaqSection-module-scss-module__4ztfSG__hpv2FadeRight",
  "hpv2FadeUp": "WebV2FaqSection-module-scss-module__4ztfSG__hpv2FadeUp",
  "hpv2FloatA": "WebV2FaqSection-module-scss-module__4ztfSG__hpv2FloatA",
  "hpv2FloatB": "WebV2FaqSection-module-scss-module__4ztfSG__hpv2FloatB",
  "hpv2HeroFadeIn": "WebV2FaqSection-module-scss-module__4ztfSG__hpv2HeroFadeIn",
  "hpv2HeroFadeInOpacity": "WebV2FaqSection-module-scss-module__4ztfSG__hpv2HeroFadeInOpacity",
  "hpv2HeroSlideIn": "WebV2FaqSection-module-scss-module__4ztfSG__hpv2HeroSlideIn",
  "hpv2PriceShimmer": "WebV2FaqSection-module-scss-module__4ztfSG__hpv2PriceShimmer",
  "hpv2PulseDot": "WebV2FaqSection-module-scss-module__4ztfSG__hpv2PulseDot",
  "hpv2ScaleUp": "WebV2FaqSection-module-scss-module__4ztfSG__hpv2ScaleUp",
  "item": "WebV2FaqSection-module-scss-module__4ztfSG__item",
  "itemOpen": "WebV2FaqSection-module-scss-module__4ztfSG__itemOpen",
  "list": "WebV2FaqSection-module-scss-module__4ztfSG__list",
  "questionBtn": "WebV2FaqSection-module-scss-module__4ztfSG__questionBtn",
  "sectionHeader": "WebV2FaqSection-module-scss-module__4ztfSG__sectionHeader",
  "sectionTitle": "WebV2FaqSection-module-scss-module__4ztfSG__sectionTitle",
});
